module.exports = __webpack_public_path__ + "static/Cloud_Solutions-68b21271f1b4b7ebec3eb26109cbb899.png";